import { render, staticRenderFns } from "./footbox.vue?vue&type=template&id=b2dbf1ac&scoped=true&"
import script from "./footbox.vue?vue&type=script&lang=js&"
export * from "./footbox.vue?vue&type=script&lang=js&"
import style0 from "./footbox.vue?vue&type=style&index=0&id=b2dbf1ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dbf1ac",
  null
  
)

export default component.exports